import { useState, useRef, useEffect } from "react";
import { useI18n } from "../../i18n";
import { Coins, Check } from "lucide-react";

export default function CurrencySwitcher() {
  const { ccy, setCcy, currencies } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const list = Object.values(currencies);

  return (
    <div ref={ref} className="relative">
      <button data-testid="ccy-switcher" onClick={() => setOpen((v) => !v)}
        className="h-10 px-3 rounded-full border border-[#23232a] hover:border-[color:var(--gold)] flex items-center gap-2 text-xs font-mono uppercase tracking-widest">
        <Coins className="w-3.5 h-3.5 text-[color:var(--gold)]" />
        <span>{currencies[ccy].symbol}</span>
        <span className="hidden sm:inline">{ccy}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-48 rounded-xl border border-[#23232a] bg-[#0f0f12] shadow-2xl overflow-hidden z-50">
          {list.map((c) => (
            <button key={c.code} data-testid={`ccy-${c.code}`}
              onClick={() => { setCcy(c.code); setOpen(false); }}
              className={`w-full px-4 py-2.5 text-left text-sm flex items-center gap-3 hover:bg-[rgba(231,180,59,.06)] ${
                c.code === ccy ? "text-[color:var(--gold)]" : "text-[color:var(--ink-dim)]"
              }`}>
              <span className="text-base">{c.flag}</span>
              <span className="flex-1">{c.symbol} {c.code}</span>
              {c.code === ccy && <Check className="w-3.5 h-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
